import {
  DownOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { memo, useEffect, useState } from "react";
import Question from "../Question/Question";
import MultiOption from "../MultiOption/MultiOption";
import SwapElements from "../../../Util/reorder";
import reorder from "../../../Util/reorder";

const MultiDropdown = ({
  index,
  id,
  noNumber,
  disabled,
  duplicateQuestion,
  duplicateSubQuestion,
  field_type,
  label,
  questions,
  required,
  description,
  onChange,
  newOptionId,
  newQuestionId,
  setNewQuestionId,
  setNewOptionId,
  onRemove,
  formContainer,
  question_number,
  deleteDuplicateOptions = false,
}) => {
  const [arrayQuestions, setArrayOfQuestions] = useState([]);
  const [showQuestions, setShowQuestions] = useState(false);
  const [updateForcer, setUpdateForcer] = useState(0);

  useEffect(() => {
    if (Array.isArray(questions)) {
      setArrayOfQuestions(questions);
      setUpdateForcer(updateForcer + 1);
    }
  }, [questions]);

  const addQuestion = () => {
    const oldQuestions = arrayQuestions;
    const newQuestions = [...oldQuestions, { id: newQuestionId }];
    setNewQuestionId(newQuestionId + 1);
    setArrayOfQuestions(newQuestions);
    onChange("questions", newQuestions);
  };
  const removeSubQuestion = (id) => {
    const newQuestions = [];
    const oldQuestions = arrayQuestions;
    oldQuestions.forEach((opt) => {
      if (opt.id !== id) {
        newQuestions.push(opt);
      }
    });
    setArrayOfQuestions([]);
    setTimeout(() => {
      setArrayOfQuestions(newQuestions);
    }, 1);
    onChange("questions", newQuestions);
  };
  const editQuestion = (id, field, value) => {
    const oldQuestions = arrayQuestions;
    const newQuestions = oldQuestions.map((opt) => {
      if (opt.id === id) {
        const newOpt = opt;
        newOpt[field] = value;
        return newOpt;
      }
      return opt;
    });
    setArrayOfQuestions(newQuestions);
    onChange("questions", newQuestions);
  };

  return (
    <Question
      deleteDuplicateOptions={deleteDuplicateOptions}
      question_number={question_number}
      onChange={onChange}
      description={description}
      required={required}
      label={label}
      index={index}
      duplicateQuestion={duplicateQuestion}
      duplicateSubQuestion={duplicateSubQuestion}
      id={id}
      // type={noNumber ? `${noNumber} - چند لیست کشویی` : "چند لیست کشویی"}
      type={"چند لیست کشویی"}
      disabled={disabled}
      onRemove={onRemove}
      field_type={field_type}
      formContainer={formContainer}
    >
      <Button
        style={{ width: "100%", marginBottom: "0.5rem" }}
        onClick={() => {
          setShowQuestions(!showQuestions);
        }}
        type="ghost"
        icon={showQuestions ? <UpOutlined /> : <DownOutlined />}
      >
        سوال‌ها
      </Button>
      {showQuestions &&
        arrayQuestions.map((question, index) => {
          return (
            <MultiOption
              duplicateSubQuestion={duplicateSubQuestion}
              setNewOptionId={setNewOptionId}
              newOptionId={newOptionId}
              index={index}
              reOrder={reorder(
                arrayQuestions,
                setArrayOfQuestions,
                onChange,
                "questions",
                index
              )}
              onRemove={() => {
                removeSubQuestion(question.id);
              }}
              noDetail
              {...question}
              onChange={(field, value) => {
                editQuestion(question.id, field, value);
              }}
            />
          );
        })}
      {showQuestions && (
        <Button
          disabled={disabled}
          type="dashed"
          onClick={() => addQuestion()}
          style={{
            width: "100%",
          }}
          icon={<PlusOutlined />}
        >
          اضافه کردن سوال
        </Button>
      )}
    </Question>
  );
};

export default memo(MultiDropdown);
